export const ids = ['BEDC', 'internal', 'external'] as const;
